import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import { BASE_LAYER, BASE_LAYER_INFO, LAYER_TYPES, MapLayerState } from '../../map_types';
import styles from './base_modal.less';

export const BaseModal = ({
  mapLayerState,
  onBaseLayerChange,
  onClose,
  isOpen,
}: {
  mapLayerState: MapLayerState;
  onBaseLayerChange: (val: BASE_LAYER) => void;
  onClose: () => void;
  isOpen: boolean;
}) => {
  const baseLayers = Object.values(BASE_LAYER_INFO);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.baseModal}>
      <div className={styles.header}>
        <span>Base Maps</span>
        <span className={styles.closeIcon} onClick={onClose}>
          <CloseOutlined />
        </span>
      </div>
      <fieldset className={styles.fieldset}>
        {baseLayers.map((baseLayer) => {
          const isSelected = mapLayerState[LAYER_TYPES.BASE] === baseLayer.value;
          return (
            <div className={styles.baseLayerContainer} key={baseLayer.name}>
              <label
                htmlFor={baseLayer.name}
                key={baseLayer.name}
                className={classNames(styles.label, {
                  [styles.label__selected]: isSelected,
                })}
              >
                <img src={baseLayer.imgSrc} alt={baseLayer.name} className={styles.baseLayerImg} />
                <input
                  type="radio"
                  id={baseLayer.name}
                  checked={isSelected}
                  name="baseLayer"
                  value={baseLayer.value}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={(e) => {
                    const layer = e.target.value;
                    onBaseLayerChange(layer as BASE_LAYER);
                  }}
                />
                {isSelected && (
                  <span className={styles.checkMark}>
                    <CheckOutlined />
                  </span>
                )}
              </label>
              <span
                className={classNames(styles.baseLayerName, {
                  [styles.baseLayerName__selected]: isSelected,
                })}
              >
                {baseLayer.name}
              </span>
            </div>
          );
        })}
      </fieldset>
    </div>
  );
};
